import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.jsx'
import { getToken } from './csrf.js'
import { API_BASE_URL } from './api.js'
import { initErrorReporting, apiBreadcrumb } from './errorReporting.js'
// Side-effect import: parks `beforeinstallprompt` the moment it fires. It is
// dispatched once per page load and can arrive before the tree that shows the
// invitation has mounted, so the listener has to exist this early.
import './pwaInstall.js'

const _originalFetch = window.fetch.bind(window);
window.fetch = async (url, options = {}) => {
  const isApi = typeof url === 'string' &&
    (url.includes('api.autodealerug.com') || url.startsWith(API_BASE_URL));
  if (isApi) {
    const token = getToken();
    if (token) {
      options = { ...options, headers: { ...options.headers, 'X-CSRF-Token': token } };
    }
  }
  const started = Date.now();
  const response = await _originalFetch(url, options);
  if (isApi) {
    apiBreadcrumb(url, options, response.status, Date.now() - started);
    if (response.status === 401 && !url.includes('/getuserdata')) {
      window.dispatchEvent(new Event('session-expired'));
    }
    // While the API restarts, nginx answers 502/503/504 with an HTML error
    // page; callers that res.json() it surface "Unexpected token '<'".
    // Substitute a JSON body with a human message. Only when the body isn't
    // JSON — the app's own 503s (e.g. /ai's { aiDisabled }) must pass through.
    if ([502, 503, 504].includes(response.status) &&
        !(response.headers.get('content-type') || '').includes('application/json')) {
      return new Response(
        JSON.stringify({ ok: false, message: 'The server is restarting — please try again in a moment.' }),
        { status: response.status, headers: { 'Content-Type': 'application/json' } }
      );
    }
  }
  return response;
};

initErrorReporting();
import { Theme } from "@radix-ui/themes";
import "./bootstrap-compat.css";
import "./index.css";
import "./theme.css";
import "./carstyles.css";
import "@radix-ui/themes/styles.css";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient();

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Theme
    accentColor="blue"
    grayColor="gray"
    panelBackground="solid"
    scaling="100%"
    radius="full"
  >
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </Theme>
  
);